/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : DROP DOWN ITEM : STYLES --------------- ++++++++++ */
export default theme => ({
    dropDownItem: {
        display: 'flex',
        alignItems: 'center',
        padding: replacePXinStringWithEM('16px 0'),
        fontSize: pxToEm(14),
        fontWeight: '500',
        color: theme.color.supporting.medium.swatch,
        background: theme.color.light.light.swatch,
        cursor: 'pointer',
        transition: 'all .15s',
        '&:hover':{
            color: theme.color.primary.medium.swatch
        },
        '& .highlight':{
            fontWeight: '600',
            background: theme.color.primary.light.swatch
        }
    }
});
